import { Binding } from "@ortho-next/three-base";
import { bindedModelBase } from "../Models/BindedModel.js";
/**
 * Binds layers logic and visibility
 */
export class LayersBase {
    constructor(main) {
        this._main = main;
    }
    /**
     * Creates all bindings.
     */
    createAllBinding() {
        this.createLinesBinding();
        this.createGoniometersBinding();
        this.createLabelsBinding();
    }
    /**
     * Set on/off value to a specific layer.
     */
    setLayersVisibility(key, value) {
        switch (key) {
            case "lines":
                bindedModelBase.layer_lines = value;
                return;
            case "goniometers":
                bindedModelBase.layer_goniometers = value;
                return;
            case 'labels':
                bindedModelBase.layer_labels = value;
                return;
        }
    }
    createBinding(name, getCallback, setCallback, propertiesBound) {
        Binding.createCustom(name, getCallback, (value) => {
            setCallback(value);
            if (value) {
                this._main.model.layersVisible = true;
            }
            else {
                const layers = this._main.model.layers;
                for (const key in layers) {
                    if (layers[key])
                        return;
                }
                this._main.model.layersVisible = false;
            }
        }, propertiesBound);
    }
    createBindingValue(name, bindedModelKey, appModelKey) {
        Binding.createCustom(`${name}_value`, (m) => m[bindedModelKey], (value) => {
            this._main.model.layersValue[appModelKey] = value;
        }, [bindedModelKey]);
    }
    createLinesBinding() {
        this.createBinding("layerLines", (m) => m.linesMaskAP > 0 || m.linesMaskLT > 0, (value) => {
            this._main.model.layers.lines = value;
        }, ["linesMaskAP", "linesMaskLT"]);
        this.createBindingValue("layerLines", "layer_lines", "lines");
    }
    createGoniometersBinding() {
        this.createBinding("layerGoniometers", (m) => m.goniometersMaskAP > 0 || m.goniometersMaskLT > 0, (value) => {
            this._main.model.layers.goniometers = value;
        }, ["goniometersMaskAP", "goniometersMaskLT"]);
        this.createBindingValue("layerGoniometers", "layer_goniometers", "goniometers");
    }
    createLabelsBinding() {
        this.createBindingValue("layerLabels", "layer_labels", "labels");
    }
}
//# sourceMappingURL=Layers.js.map